<template>
  <div>
    <span style="white-space: normal"
          v-for="obj in highlights"
          :class="{'badge badge-primary': obj.isHighlighted}">{{obj.text}}</span>
  </div>
</template>

<script>
import highlightChunks from "./highlightChunks.js";

export default {
  props: ['text', 'query'],

  watch: {
    highlights(val) {
      this.$emit('highlightsCount', this.highlights.filter(el => el.isHighlighted).length)
    }
  },

  computed: {
    highlights() {
      return highlightChunks(this.text, [this.query])
    }
  }
}
</script>